import { IBaseIconProps } from "./IBaseIconProps";

export const EnvelopeIcon2 = () => {
  return (
    <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="2"
        y="4"
        width="20"
        height="16"
        rx="2"
        stroke={"#3d0829"}
        strokeWidth="1.5"
        fill="none"
      />
      <path
        stroke={"#3d0829"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2 7l10 7 10-7"
      />
    </svg>
  );
};
